import {CharacteristicsDialog} from '@/modules/patients/components/dialogs/characteristics-dialog'
import {dialog} from '@cypro/ui/components'

export function openPatientCharacteristicsDialog(patientId: string) {
  return dialog.open('patient-characteristics', {
    children: <CharacteristicsDialog patientId={patientId} />,
  })
}
